function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M29.25 3H6.75C4.679 3 3 4.455 3 6.25v13c0 1.795 1.679 3.25 3.75 3.25h9.75v6h-4.8a1.2 1.2 0 000 2.4h12.6a1.2 1.2 0 000-2.4h-5.4v-6h10.35c2.071 0 3.75-1.455 3.75-3.25v-13C33 4.455 31.321 3 29.25 3zM5.5 6.25c0-.598.56-1.083 1.25-1.083h22.5c.69 0 1.25.485 1.25 1.083v13c0 .598-.56 1.083-1.25 1.083H6.75c-.69 0-1.25-.485-1.25-1.083v-13z",
  fill: "#000"
});

var SvgDeviceDesktop = function SvgDeviceDesktop(props) {
  return React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/device-desktop.b64c28f9.svg";
export { SvgDeviceDesktop as ReactComponent };